import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { PoSyncSchema } from '@po-ui/ng-sync';
import { Observable, firstValueFrom } from 'rxjs';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { environment } from 'src/environments/environment';
import { BaseResourceApi } from '../interfaces/base-resource-api.model';
import { ISchemaAPI, Schema } from '../interfaces/schema.model';
import { LiteralsService } from './literals-service';
import { Functions } from '../functions/functions';

@Injectable({
  providedIn: 'root'
})
export class SchemasService {
  protected literalsService: LiteralsService;
  literals: LiteralsWords;
  constructor(private http: HttpClient, protected injector: Injector, protected functions: Functions) {
    this.literalsService = injector.get(LiteralsService);
    this.literals = this.literalsService.getLiteralModule();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async getSchemas(): Promise<any> {
    const data$ = this.http.get<PoSyncSchema[]>(`${environment.url}api/tgv/schemas`);
    const schemas = await firstValueFrom(data$);
    return schemas;
  }

  async getSchemaAll(): Promise<PoSyncSchema[]> {
    const schemas = await this.getSchemas();

    return new Promise((resolve, reject) => {
      if (schemas?.items !== undefined) {
        const items = [];
        schemas.items.map((schema: Schema) => {
          if (this.validateOfflineSchemas(schema.name)) {
            schema.getUrlApi = `${environment.url}${schema.getUrlApi}`;
            schema.diffUrlApi = `${environment.url}${schema.diffUrlApi}`;
            schema.pageSize = 100;
            if (schema.patchUrlApi) {
              schema.patchUrlApi = `${environment.url}${schema.patchUrlApi}`;
            }

            items.push(schema);
          }
        });
        resolve(items);
      } else {
        reject(schemas);
      }
    });
  }

  async getSchemaForSettings(): Promise<BaseResourceApi> {
    const schemas = await this.getSchemas();

    return new Promise((resolve, reject) => {
      if (schemas?.items !== undefined) {
        schemas.items = schemas.items.filter(
          e => e.name === 'Customer' || e.name === 'Products' || e.name === 'Prospects'
        );

        schemas.items = schemas.items.map(schemas => ({ ...schemas, edit: this.literals.str0578 }));
        resolve(schemas);
      } else {
        reject(schemas);
      }
    });
  }

  validateOfflineSchemas(schema: string | undefined): boolean {
    const isLastVersion = this.isLastVersion();
    const isLastVersionBudget = this.isLastVersionBudget();
    switch (schema) {
      case 'Notification':
        return false;
      case 'Customer':
        return isLastVersion;
      case 'Contacts':
        return false;
      case 'PhoneContacts':
        return false;
      case 'Financialstatus':
        return false;
      case 'Prospects':
        return isLastVersionBudget;
      case 'SalesBudgets':
        return isLastVersionBudget;
      case 'SalesBudgetsItems':
        return isLastVersionBudget;
      case 'SalesOrders':
        return isLastVersion;
      case 'SalesOrdersItems':
        return isLastVersion;
      case 'Products':
        return isLastVersion;
      case 'PriceListItem':
        return isLastVersion;
      default:
        return true;
    }
  }

  isLastVersionBudget(): boolean{
    return this.functions.checkVersion('1.4.8');
  }

  isLastVersion(): boolean{
    return this.functions.checkVersion('1.4.1');
  }

  hasSchemas(): Observable<boolean> {
    return new Observable(subscriber => {
      this.http.get<ISchemaAPI>(`${environment.url}api/tgv/schemas`).subscribe({
        next: schemas => {
          if (Object.keys(schemas).length === 0) {
            subscriber.next(false);
          } else {
            subscriber.next(true);
          }
        },
        error: error => subscriber.error(error)
      });
    });
  }
}
